export default __webpack_public_path__ + "static/media/illus15.ae3ff000.png";